import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info__label" }
const _hoisted_3 = { class: "info__value" }
const _hoisted_4 = { class: "info__value--num" }
const _hoisted_5 = { class: "date-input__container" }
const _hoisted_6 = { class: "date-input" }

import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import DateInput from '@/corePagesModule/components/DateInput.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeEtaModal',
  props: {
    modalState: { type: Boolean },
    selectedCount: {}
  },
  emits: ["next", "close"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

const eta = ref<number>(0);

watch(
  () => props.modalState,
  () => (eta.value = 0)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": props.modalState,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('変更'),
    "is-disabled-next-button": !eta.value,
    onOnNext: _cache[1] || (_cache[1] = ($event: any) => (emits('next', eta.value))),
    onOnBack: _cache[2] || (_cache[2] = ($event: any) => (emits('close')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('納期の一括変更')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('変更後の納期を入力してください')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('選択されている発注')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedCount), 1),
          _createTextVNode(" " + _toDisplayString(_unref(t)('件')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DateInput, {
            "model-value": eta.value,
            "display-icon": "",
            "text-centering": "",
            "auto-apply": "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (eta.value = $event))
          }, null, 8, ["model-value"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})